import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { FiShoppingBag, FiTag } from "react-icons/fi"

import { buyCourse } from "../../../../services/operations/studentFeaturesAPI"

export default function RenderTotalAmount() {
  const { total, cart } = useSelector((state) => state.cart)
  const { token } = useSelector((state) => state.auth)
  const { user } = useSelector((state) => state.profile)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleBuyCourse = () => {
    const courses = cart.map((course) => course._id)
    buyCourse(token, courses, user, navigate, dispatch)
  }

  return (
    <div className="rounded-2xl border border-richblack-700 bg-richblack-800 p-5">
      <p className="mb-4 text-sm font-semibold uppercase tracking-wide text-richblack-400">
        Order Summary
      </p>

      {/* Per-course breakdown */}
      <div className="mb-4 flex flex-col gap-2">
        {cart.map((course) => (
          <div key={course._id} className="flex items-center justify-between gap-2">
            <p className="line-clamp-1 flex-1 text-xs text-richblack-300">
              {course.courseName}
            </p>
            <p className="flex-shrink-0 text-xs font-medium text-richblack-100">
              ₹{course?.price?.toLocaleString("en-IN")}
            </p>
          </div>
        ))}
      </div>

      {/* Divider */}
      <div className="mb-4 border-t border-richblack-700" />

      {/* Total */}
      <div className="mb-5 flex items-center justify-between">
        <p className="text-sm font-medium text-richblack-200">Total</p>
        <p className="text-2xl font-bold text-yellow-50">
          ₹{total?.toLocaleString("en-IN")}
        </p>
      </div>

      {/* Buy button */}
      <button
        onClick={handleBuyCourse}
        className="flex w-full items-center justify-center gap-2 rounded-xl bg-yellow-50 py-3 text-sm font-bold text-richblack-900 shadow-sm transition-all hover:bg-yellow-100 active:scale-[0.98]"
      >
        <FiShoppingBag size={15} />
        Proceed to Payment
      </button>

      {/* Trust note */}
      <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-[11px] text-richblack-500">
        <FiTag size={11} />
        30-day money-back guarantee
      </p>
    </div>
  )
}
